import * as React from "react";
const SvgFiRrUserCowboy = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-cowboy_svg__a)">
      <path
        fill="#062147"
        d="M23.63 2.228a1 1 0 0 0-1.405.141c-.083.1-1.46 1.713-4.533 2.755C17.08 2.579 15.672.001 14.43.001c-1.142 0-1.717.481-2.098.8-.24.2-.255.2-.332.2s-.092 0-.332-.2c-.381-.318-.956-.8-2.098-.8-1.243 0-2.651 2.579-3.262 5.124-3.062-1.04-4.441-2.645-4.532-2.756A1 1 0 0 0 .222 3.627C.324 3.753 2.097 5.879 6 7.119V8c0 3.309 2.69 6 6 6s6-2.691 6-6v-.881c3.904-1.24 5.677-3.365 5.779-3.492a.996.996 0 0 0-.15-1.399M9.836 2.021c.222.04.344.142.549.313.317.265.797.666 1.615.666s1.298-.401 1.615-.666c.205-.172.327-.273.549-.313.409.481 1.205 1.936 1.602 3.617A19 19 0 0 1 11.999 6a19 19 0 0 1-3.766-.362c.397-1.68 1.193-3.136 1.602-3.617M12 12c-2.206 0-4-1.794-4-4v-.371C9.184 7.858 10.512 8 12 8s2.816-.142 4-.371V8c0 2.206-1.794 4-4 4m7.99 10.856a1 1 0 1 1-1.98.288C17.586 20.211 15.003 18 12 18c-3 0-5.583 2.211-6.01 5.144a.995.995 0 0 1-1.132.846 1 1 0 0 1-.846-1.133c.567-3.909 4.002-6.856 7.99-6.856s7.422 2.947 7.99 6.856z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-cowboy_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserCowboy;
